export class Permission {
  accessConsole = false;
  manageUsers = false;
  ManageResetSecurityQuestions = false;
  managePreloadPasswords = false;
  copyPasswordPreloadPassword = false;
  managePreloadUrls = false;
  createPassword = false;
  manageSetting = false;
  makePasswordVisible = false;
  manageGrc = false;
  grcAccessGovernance = false;
  grcAppUsage = false;
  createLoginForPreloadUrl = false;
  manageUpdateServer = false;
  manageIpRestriction = false;
  copyPassword = false;
  requireExtensionCode = false;
  createPasswordForPreloadUrl = false;
  accessSettings = false;
  activateMobile = false;
  deletePreloadPasswordByTemplate = false;
  deleteUsersByTemplate = false;
  manageCreditCards = false;
  deleteCreditCardsByTemplate = false;
  copyCVV = false;
  viewCVV = false;
  manageApplicationAccess = false;
  deleteApplicationAccessByTemplate = false;
  makeAccessAKPasswordVisible = false;
  copyAccessAKPassword = false;
  seeCardNumber = false;
  seePasswords = false;
  seeCreditCards = false;
  seePreloadedUserAccess = false;
  manageDeviceRestriction = false;
  applyDeviceRestriction = false;
  clearInputFieldsByExtension = false;
  scanTwoFAAccessKit = false;
  accessDashboard = false;
  loginWithoutTFA = false;
  manageDisableAutoFillExtension = false;
  rememberSecurityAnswers = false;
  reportsUserInactivity = false;
  forceTwoFactor = false;
  manageCredentialProvider = false;

  constructor(input: any) {
    this.accessConsole = input.accessConsole;
    this.manageUsers = input.manageUsers;
    this.ManageResetSecurityQuestions = input.ManageResetSecurityQuestions;
    this.managePreloadPasswords = input.managePreloadPasswords;
    this.copyPasswordPreloadPassword = input.copyPasswordPreloadPassword;
    this.managePreloadUrls = input.managePreloadUrls;
    this.createPassword = input.createPassword;
    this.manageSetting = input.manageSetting;
    this.makePasswordVisible = input.makePasswordVisible;
    this.manageGrc = input.manageGrc;
    this.grcAccessGovernance = input.grcAccessGovernance;
    this.grcAppUsage = input.grcAppUsage;
    this.createLoginForPreloadUrl = input.createLoginForPreloadUrl;
    this.manageUpdateServer = input.manageUpdateServer;
    this.manageIpRestriction = input.manageIpRestriction;
    this.copyPassword = input.copyPassword;
    this.requireExtensionCode = input.requireExtensionCode;
    this.createPasswordForPreloadUrl = input.createPasswordForPreloadUrl;
    this.accessSettings = input.accessSettings;
    this.activateMobile = input.activateMobile;
    this.deletePreloadPasswordByTemplate = input.deletePreloadPasswordByTemplate;
    this.deleteUsersByTemplate = input.deleteUsersByTemplate;
    this.manageCreditCards = input.manageCreditCards;
    this.deleteCreditCardsByTemplate = input.deleteCreditCardsByTemplate
    this.viewCVV = input.viewCVV;
    this.copyCVV = input.copyCVV;
    this.manageApplicationAccess = input.manageApplicationAccess;
    this.deleteApplicationAccessByTemplate = input.deleteApplicationAccessByTemplate;
    this.makeAccessAKPasswordVisible = input.makeAccessAKPasswordVisible;
    this.copyAccessAKPassword = input.copyAccessAKPassword;
    this.seeCardNumber = input.seeCardNumber;
    this.seePasswords = input.seePasswords;
    this.seeCreditCards = input.seeCreditCards;
    this.seePreloadedUserAccess = input.seePreloadedUserAccess;
    this.manageDeviceRestriction = input.manageDeviceRestriction;
    this.applyDeviceRestriction = input.applyDeviceRestriction;
    this.clearInputFieldsByExtension = input.clearInputFieldsByExtension;
    this.scanTwoFAAccessKit = input.scanTwoFAAccessKit;
    this.accessDashboard = input.accessDashboard;
    this.loginWithoutTFA = input.loginWithoutTFA;
    this.manageDisableAutoFillExtension = input.manageDisableAutoFillExtension;
    this.rememberSecurityAnswers = input.rememberSecurityAnswers;
    this.reportsUserInactivity = input.reportsUserInactivity;
    this.forceTwoFactor = input.forceTwoFactor
    this.manageCredentialProvider = input.manageCredentialProvider;

  }

  deepEqual(obj2: Permission): boolean {
    if (!this || !obj2) return false;

    const keysToCompare = [
      'accessDashboard',
      'manageUsers',
      'manageApplicationAccess',
      'managePreloadUrls',
      'managePreloadPasswords',
      'manageCreditCards',
      'manageGrc',
      'grcAccessGovernance',
      'grcAppUsage',
    ];

    for (const key of keysToCompare) {
      if (this[key] !== obj2[key]) return false;
    }

    return true;
  }
}


export class Role {
  id?: number;
  level: number;
  name = '';
  permission: Permission = new Permission({});
  lightTheme: '#002662';
  darkTheme: '#57575b';
  darkText: '#ffffff';
  lightText: '#ffffff';
  constructor(input: any) {
    if (input.id) {
      this.id = input.id as number;
    }
    this.level = input.level;
    this.name = input.name ? input.name : '';
    this.permission = new Permission(input.permission ? input.permission : {});
    this.lightTheme = input.lightTheme ? input.lightTheme : '#002662';
    this.darkTheme = input.darkTheme ? input.darkTheme : '#57575b';
    this.lightText = input.lightText ? input.lightText : '#FFFFFF';
    this.darkText = input.darkText ? input.darkText : '#FFFFFF';
  }
  prepareFilterSearch(pagination, extraFilter?) {
    const filter: any = {};
    filter.linePerPage = pagination.limit;
    filter.page = pagination.offset;
    if (extraFilter && extraFilter.replace(/\s/g, '').length > 0) {
      filter.search = extraFilter;
    }
    if (this.name && this.name.replace(/\s/g, '').length > 0) {
      filter.name = this.name;
    }
    if (this.permission.accessConsole === true || this.permission.accessConsole === false) {
      filter.accessConsole = this.permission.accessConsole ? 1 : 0;
    }
    if (this.permission.manageUsers === true || this.permission.manageUsers === false) {
      filter.manageUsers = this.permission.manageUsers ? 1 : 0;
    }
    if (this.permission.ManageResetSecurityQuestions === true || this.permission.ManageResetSecurityQuestions === false) {
      filter.ManageResetSecurityQuestions = this.permission.ManageResetSecurityQuestions ? 1 : 0;
    }
    if (this.permission.managePreloadPasswords === true || this.permission.managePreloadPasswords === false) {
      filter.managePreloadPasswords = this.permission.managePreloadPasswords ? 1 : 0;
    }
    if (this.permission.copyPasswordPreloadPassword === true || this.permission.copyPasswordPreloadPassword === false) {
      filter.copyPasswordPreloadPassword = this.permission.copyPasswordPreloadPassword ? 1 : 0;
    }
    if (this.permission.managePreloadUrls === true || this.permission.managePreloadUrls === false) {
      filter.managePreloadUrls = this.permission.managePreloadUrls ? 1 : 0;
    }
    if (this.permission.createPassword === true || this.permission.createPassword === false) {
      filter.createPassword = this.permission.createPassword ? 1 : 0;
    }
    if (this.permission.manageSetting === true || this.permission.manageSetting === false) {
      filter.manageSetting = this.permission.manageSetting ? 1 : 0;
    }
    if (this.permission.makePasswordVisible === true || this.permission.makePasswordVisible === false) {
      filter.makePasswordVisible = this.permission.makePasswordVisible ? 1 : 0;
    }
    if (this.permission.manageGrc === true || this.permission.manageGrc === false) {
      filter.manageGrc = this.permission.manageGrc ? 1 : 0;
    }
    if (this.permission.grcAccessGovernance === true || this.permission.grcAccessGovernance === false) {
      filter.grcAccessGovernance = this.permission.grcAccessGovernance ? 1 : 0;
    }
    if (this.permission.grcAppUsage === true || this.permission.grcAppUsage === false) {
      filter.grcAppUsage = this.permission.grcAppUsage ? 1 : 0;
    }
    if (this.permission.manageUpdateServer === true || this.permission.manageUpdateServer === false) {
      filter.manageUpdateServer = this.permission.manageUpdateServer ? 1 : 0;
    }
    if (this.permission.manageIpRestriction === true || this.permission.manageIpRestriction === false) {
      filter.manageIpRestriction = this.permission.manageIpRestriction ? 1 : 0;
    }
    if (this.permission.createLoginForPreloadUrl === true || this.permission.createLoginForPreloadUrl === false) {
      filter.createLoginForPreloadUrl = this.permission.createLoginForPreloadUrl ? 1 : 0;
    }
    if (this.permission.copyPassword === true || this.permission.copyPassword === false) {
      filter.copyPassword = this.permission.copyPassword ? 1 : 0;
    }
    if (this.permission.requireExtensionCode === true || this.permission.requireExtensionCode === false) {
      filter.requireExtensionCode = this.permission.requireExtensionCode ? 1 : 0;
    }
    if (this.permission.accessSettings === true || this.permission.accessSettings === false) {
      filter.accessSettings = this.permission.accessSettings ? 1 : 0;
    }
    if (this.permission.createPasswordForPreloadUrl === true || this.permission.createPasswordForPreloadUrl === false) {
      filter.createPasswordForPreloadUrl = this.permission.createPasswordForPreloadUrl ? 1 : 0;
    }
    if (this.permission.activateMobile === true || this.permission.activateMobile === false) {
      filter.activateMobile = this.permission.activateMobile ? 1 : 0;
    }
    if (this.permission.deletePreloadPasswordByTemplate === true || this.permission.deletePreloadPasswordByTemplate === false) {
      filter.deletePreloadPasswordByTemplate = this.permission.deletePreloadPasswordByTemplate ? 1 : 0;
    }
    if (this.permission.deleteUsersByTemplate === true || this.permission.deleteUsersByTemplate === false) {
      filter.deleteUsersByTemplate = this.permission.deleteUsersByTemplate ? 1 : 0;
    }
    if (this.permission.manageCreditCards === true || this.permission.manageCreditCards === false) {
      filter.manageCreditCards = this.permission.manageCreditCards ? 1 : 0;
    }
    if (this.permission.deleteCreditCardsByTemplate === true || this.permission.deleteCreditCardsByTemplate === false) {
      filter.deleteCreditCardsByTemplate = this.permission.deleteCreditCardsByTemplate ? 1 : 0;
    }
    if (this.permission.copyCVV === true || this.permission.copyCVV === false) {
      filter.copyCVV = this.permission.copyCVV ? 1 : 0;
    }
    if (this.permission.viewCVV === true || this.permission.viewCVV === false) {
      filter.viewCVV = this.permission.viewCVV ? 1 : 0;
    }
    if (this.permission.manageApplicationAccess === true || this.permission.manageApplicationAccess === false) {
      filter.manageApplicationAccess = this.permission.manageApplicationAccess ? 1 : 0;
    }
    if (this.permission.makeAccessAKPasswordVisible === true || this.permission.makeAccessAKPasswordVisible === false) {
      filter.makeAccessAKPasswordVisible = this.permission.makeAccessAKPasswordVisible ? 1 : 0;
    }
    if (this.permission.copyAccessAKPassword === true || this.permission.copyAccessAKPassword === false) {
      filter.copyAccessAKPassword = this.permission.copyAccessAKPassword ? 1 : 0;
    }
    if (this.permission.deleteApplicationAccessByTemplate === true || this.permission.deleteApplicationAccessByTemplate === false) {
      filter.deleteApplicationAccessByTemplate = this.permission.deleteApplicationAccessByTemplate ? 1 : 0;
    }
    if (this.permission.seeCardNumber === true || this.permission.seeCardNumber === false) {
      filter.seeCardNumber = this.permission.seeCardNumber ? 1 : 0;
    }
    if (this.permission.seePasswords === true || this.permission.seePasswords === false) {
      filter.seePasswords = this.permission.seePasswords ? 1 : 0;
    }
    if (this.permission.seeCreditCards === true || this.permission.seeCreditCards === false) {
      filter.seeCreditCards = this.permission.seeCreditCards ? 1 : 0;
    }
    if (this.permission.seePreloadedUserAccess === true || this.permission.seePreloadedUserAccess === false) {
      filter.seePreloadedUserAccess = this.permission.seePreloadedUserAccess ? 1 : 0;
    }
    if (this.permission.manageDeviceRestriction === true || this.permission.manageDeviceRestriction === false) {
      filter.manageDeviceRestriction = this.permission.manageDeviceRestriction ? 1 : 0;
    }
    if (this.permission.applyDeviceRestriction === true || this.permission.applyDeviceRestriction === false) {
      filter.applyDeviceRestriction = this.permission.applyDeviceRestriction ? 1 : 0;
    }
    if (this.permission.clearInputFieldsByExtension === true || this.permission.clearInputFieldsByExtension === false) {
      filter.clearInputFieldsByExtension = this.permission.clearInputFieldsByExtension ? 1 : 0;
    }
    if (this.permission.scanTwoFAAccessKit === true || this.permission.scanTwoFAAccessKit === false) {
      filter.scanTwoFAAccessKit = this.permission.scanTwoFAAccessKit ? 1 : 0;
    }
    if (this.permission.accessDashboard === true || this.permission.accessDashboard === false) {
      filter.accessDashboard = this.permission.accessDashboard ? 1 : 0;
    }
    if (this.permission.loginWithoutTFA === true || this.permission.loginWithoutTFA === false) {
      filter.loginWithoutTFA = this.permission.loginWithoutTFA ? 1 : 0;
    }
    if (this.permission.manageDisableAutoFillExtension === true || this.permission.manageDisableAutoFillExtension === false) {
      filter.manageDisableAutoFillExtension = this.permission.manageDisableAutoFillExtension ? 1 : 0;
    }
    if (this.permission.rememberSecurityAnswers === true || this.permission.rememberSecurityAnswers === false) {
      filter.rememberSecurityAnswers = this.permission.rememberSecurityAnswers ? 1 : 0;
    }
    if (this.permission.reportsUserInactivity === true || this.permission.reportsUserInactivity === false) {
      filter.reportsUserInactivity = this.permission.reportsUserInactivity ? 1 : 0;
    }
    if (this.permission.forceTwoFactor === true || this.permission.forceTwoFactor === false) {
      filter.forceTwoFactor = this.permission.forceTwoFactor ? 1 : 0;
    }
    if (this.permission.manageCredentialProvider === true || this.permission.manageCredentialProvider === false) {
      filter.manageCredentialProvider = this.permission.manageCredentialProvider ? 1 : 0;
    }
    return filter;
  }

  isEmpty(): boolean {
    if (this.name && this.name.length !== 0) {
      return true;
    }
    for (const key in this.permission) {
      if (this.permission.hasOwnProperty(key) && typeof this.permission[key] === 'boolean') {
        if (this.permission[key] === true || this.permission[key] === false) {
          return true;
        }
      }
    }
    return false;
  }
}
